import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}
const _hoisted_3 = ["disabled"]

import { ref, computed } from 'vue';


import { defineComponent, defineProps, onMounted } from 'vue'
import { useStore } from "vuex";
import { Notyf } from "notyf";
import { useI18n } from 'vue-i18n';

const props = defineProps(['appointmentData'])
const store = useStore()

const notyf = new Notyf()

const __default__ = defineComponent({
  name: "MngAppointmentRecordTableRow",

  methods: {
    formatSchedule(schedule: string): string
    {
      // Split the schedule string by space
      const parts = schedule.split(' ');
      // Split the time part (parts[1]) by ':'
      const timeParts = parts[1].split(':');
      // Combine the date part (parts[0]) and only the hour and minute parts of the time
      return parts[0] + ' ' + timeParts[0] + ':' + timeParts[1];
    }
  }
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: ['appointmentData'],
  setup(__props) {

const props = __props
const store = useStore()
const detailsLoading = ref(false);

const considerInsurance = computed(() => process.env.VUE_APP_CONSIDER_INSURANCE === "true");

async function iniAppointmentData(showAppointmentData: any)
{
  detailsLoading.value = true;
  try
  {
    await store.dispatch('iniEditedAppointment', showAppointmentData.appointment_id);
    await store.dispatch('resetAppointmentFiles');
    await store.dispatch('iniEditedAppointmentFiles', showAppointmentData.appointment_id);

    store.dispatch('toggleAppointmentDetailing', false);
    store.dispatch('toggleShowingAppointmentData', false);
  }
  finally
  {
    detailsLoading.value = false;
  }

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.formatSchedule(__props.appointmentData.schedule)), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.specialty_name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.vet_name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.customer_name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.pet_name), 1)
    ]),
    (considerInsurance.value)
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
          _createElementVNode("div", null, _toDisplayString(__props.appointmentData.pet_policy), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.price), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.appointment_status), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.status_date), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["button is-warning is-small", { 'is-loading': detailsLoading.value }]),
          disabled: detailsLoading.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (iniAppointmentData(__props.appointmentData)))
        }, _toDisplayString(_ctx.$t('General.Details')), 11, _hoisted_3)
      ])
    ])
  ], 64))
}
}

})